/**
 * Wrap item in quotes if has one or more commas
 * @param {String} item
 */
const handleCommas = function(item) {
    return item.toString().indexOf(",") > -1 ? '"' + item + '"' : item;
};

/**
 * Convert JSON Object to CSV
 * Pulled from myData
 *
 * @param {Object} args
 */
const jsonToCsv = function(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) return null;

    result = "";
    columnDelimiter = args.columnDelimiter || ",";
    lineDelimiter = args.lineDelimiter || "\n";

    // Create column headers
    keys = Object.keys(data[0]);
    // Wrap all keys in quotes in case they have commas
    result += keys.map(i => `"${i}"`).join(columnDelimiter);
    result += lineDelimiter;

    // Build data rows
    data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
            if (ctr > 0) result += columnDelimiter;
            result += item[key] ? handleCommas(item[key]) : "";
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
};

export { jsonToCsv };
